import { Grid, Icon } from 'gu-ui-kit'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import styles from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/list.module.scss'
import { notificationShow } from 'modules/Notifications/actions'
import { useDispatch } from 'react-redux'
import formatMoney from 'utils/formatMoney'

export default ({ setSorting, setColumnVisibility, ...rest }) => {
  const dispatch = useDispatch()
  const writeToClipboard = useWriteToClipboard()
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  const toClipboard = useCallback((text) => {
    writeToClipboard(text)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  useEffect(() => {
    switch (true) {
      case breakpoints.sm:
        setColumnVisibility({})
        break
      case breakpoints.md:
        setColumnVisibility({})
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  return {
    columns: [
      {
        id: 'account_login',
        accessorKey: 'account_login',
        header: t(
          'recommendations::type.account-balance.table.head.account_login.label',
        ),
        cell: ({
          row: {
            original: { account_login },
          },
        }) => (
          <Grid gap={10} wrap={'nowrap'}>
            {account_login}
            <span
              onClick={() => toClipboard(account_login)}
              className={styles['copy-button']}
            >
              <Icon name={'copy'} width={20} color={'Interface-Seventh'} />
            </span>
          </Grid>
        ),
      },
      {
        id: 'week_budget',
        header: t(
          'recommendations::type.account-balance.table.head.week_budget.label',
        ),
        cell: ({
          row: {
            original: { week_budget },
          },
        }) => (
          <Grid gap={10} wrap={'nowrap'}>
            <span
              dangerouslySetInnerHTML={{
                __html: formatMoney(week_budget, 'RUB'),
              }}
            />
            <span
              onClick={() => toClipboard(week_budget)}
              className={styles['copy-button']}
            >
              <Icon name={'copy'} width={20} color={'Interface-Seventh'} />
            </span>
          </Grid>
        ),
      },
      {
        id: 'total_account_balance',
        accessorKey: 'total_account_balance',
        header: t(
          'recommendations::type.account-balance.table.head.total_account_balance.label',
        ),
        cell: ({
          row: {
            original: { total_account_balance },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(total_account_balance, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'required_deposit_amount',
        accessorKey: 'required_deposit_amount',
        header: t(
          'recommendations::type.account-balance.table.head.required_deposit_amount.label',
        ),
        cell: ({
          row: {
            original: { required_deposit_amount },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(required_deposit_amount, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'revenue',
        accessorKey: 'revenue',
        header: t(
          'recommendations::type.account-balance.table.head.revenue.label',
        ),
        cell: ({
          row: {
            original: { revenue },
          },
        }) => (
          <span
            dangerouslySetInnerHTML={{
              __html: formatMoney(revenue, 'RUB'),
            }}
          />
        ),
      },
      {
        id: 'total_account_balance_days',
        header: t(
          'recommendations::type.account-balance.table.head.total_account_balance_days.label',
        ),
        cell: ({
          row: {
            original: { total_account_balance_days = '' },
          },
        }) => total_account_balance_days,
      },
      {
        id: 'account_external_id',
        header: t(
          'recommendations::type.account-balance.table.head.account_external_id.label',
        ),
        cell: ({
          row: {
            original: { account_external_id },
          },
        }) => account_external_id ?? '',
      },
    ],
    showHeader: true,
    showFooter: false,
    onSortingChange: setSorting,
    onColumnVisibilityChange: setColumnVisibility,
    className: styles['table'],
    getRowId: ({ external_id }) => external_id,
    ...rest,
  }
}
